import img1 from "../images/ExploreEast/mg-marg.jpg";
import img2 from "../images/ExploreEast/tsomgo.jpg";
import img3 from "../images/ExploreEast/silk-route.jpg";
import img4 from "../images/ExploreEast/HanumanTok.jpeg";
import img5 from "../images/ExploreEast/Deorali.png";
import img6 from "../images/ExploreEast/Baba.jpeg";
import img7 from "../images/ExploreEast/GaneshTok.jpeg";
import img8 from "../images/ExploreEast/Tashi.jpeg";
import img9 from "../images/ExploreEast/Ban-Jhakri.png";

import northimg1 from "../images/ExploreNorth/Gurudongmar.jpeg";
import northimg2 from "../images/ExploreNorth/Yumthang.jpeg";
import northimg3 from "../images/ExploreNorth/ZeroPoint.png";
import northimg4 from "../images/ExploreNorth/Lachen.jpeg";
import northimg5 from "../images/ExploreNorth/Chungthang.jpeg";
import northimg6 from "../images/ExploreNorth/Lachung.jpeg";
import northimg7 from "../images/ExploreNorth/Nathula.jpeg";
import northimg8 from "../images/ExploreNorth/Rhodendron.jpeg";

import westsouthimg1 from "../images/ExploreWestnSouth/Barsey.jpeg";
import westsouthimg2 from "../images/ExploreWestnSouth/Buddha.jpeg";
import westsouthimg3 from "../images/ExploreWestnSouth/CharDham.jpeg";
import westsouthimg4 from "../images/ExploreWestnSouth/Samdtuptse.jpeg";
import westsouthimg5 from "../images/ExploreWestnSouth/Skywalk.jpeg";
import westsouthimg6 from "../images/ExploreWestnSouth/TemiTea .jpeg";
import westsouthimg7 from "../images/ExploreWestnSouth/RoseGarden.jpeg";

import djimg1 from "../images/ExploreDarjeeling/Chowrasta.jpeg";
import djimg2 from "../images/ExploreDarjeeling/GhoomMonastery.jpeg";
import djimg3 from "../images/ExploreDarjeeling/BatasiaLoop.jpeg";
import djimg4 from "../images/ExploreDarjeeling/HappyValley.jpeg";
import djimg5 from "../images/ExploreDarjeeling/Padmaja.jpeg";
import djimg6 from "../images/ExploreDarjeeling/TigerHill.jpeg";
import djimg7 from "../images/ExploreDarjeeling/PeacePagoda.jpeg";



export const exploreData = {
  East: {
    places: [
      { image: img1, title: "M. G. Marg", subtitle: "Gangtok" },
      { image: img2, title: "Tsomgo Lake", subtitle: "Gangtok-Nathula Highway" },
      { image: img3, title: "Old Silk Route", subtitle: "Zuluk" },
      { image: img4, title: "Hanuman Tok", subtitle: "Gangtok" },
      { image: img5, title: "Deorali Ropeway", subtitle: "Deorali, Gangtok" },
      { image: img6, title: "Baba Harbhajan Singh", subtitle: "Tsomgo Lake Highway" },
      { image: img7, title: "Ganesh Tok", subtitle: "Gangtok" },
      { image: img8, title: "Tashi View Point", subtitle: "Gangtok" },
      { image: img9, title: "Ban Jhakri Falls", subtitle: "Sichey, Gangtok" },
    ],
    itineraries: [
      "Tsomgo Lake & Nathula Pass",
      "Gangtok",
      "Old Silk Route",
    ],
  },

  North: {
    places: [
      { image: northimg1, title: "Gurudongmar Lake", subtitle: "Gurudongmar Lake" },
      { image: northimg2, title: "Yumthang Valley", subtitle: "Yumthang" },
      { image: northimg3, title: "Zero Point", subtitle: "Yumesamdong" },
      { image: northimg4, title: "Lachen Valley", subtitle: "Lachen" },
      { image: northimg5, title: "Chungthang Valley", subtitle: "Chungthang" },
      { image: northimg6, title: "Lachung Valley", subtitle: "Lachung" },
      { image: northimg7, title: "Nathula China Border", subtitle: "Nathula" },
      { image: northimg8, title: "Rhodondendron Sanctuary", subtitle: "Shingba" },
    ],
    itineraries: [
      "Lachen & Gurudongmar Lake",
      "Lachung & Yumthang Valley",
    ],
  },

  "South & West": {
    places: [
      { image: westsouthimg1, title: "Rhododendron Sanctuary", subtitle: "Barsey" },
      { image: westsouthimg2, title: "Tathagata Tsal", subtitle: "Ravangla" },
      { image: westsouthimg3, title: "Siddheshwar Dham", subtitle: "Namchi" },
      { image: westsouthimg4, title: "Samdtuptse", subtitle: "Namchi" },
      { image: westsouthimg5, title: "Sky Walk", subtitle: "pelling" },
      { image: westsouthimg6, title: "Temi Tea Garden", subtitle: "Temi-Tarku" },
      { image: westsouthimg7, title: "Rose Garden", subtitle: "Namchi" },
    ],
    itineraries: [
      "South & West",
    ],
  },

  Darjeeling: {
    places: [
      { image: djimg1, title: "Chowrasta", subtitle: "Nehru Road" },
      { image: djimg2, title: "Yiga Choeling", subtitle: "Ghoom" },
      { image: djimg3, title: "Batasia Loop", subtitle: "Hill Cart Road" },
      { image: djimg4, title: "Happy Valley Tea Estate", subtitle: "Below Hill Cart Road" },
      { image: djimg5, title: "Padmaja Naidu Himalayan Zoological Park", subtitle: "Jawahar Parbat, Darjeeling" },
      { image: djimg6, title: "Tiger Hill", subtitle: "Darjeeling" },
      { image: djimg7, title: "Peace Pagoda", subtitle: "Darjeeling" },
    ],
    itineraries: [
      "Darjeeling",
    ],
  },

  "All Sikkim": {
    places: [
      { image: img1, title: "M. G. Marg", subtitle: "Gangtok" },
      { image: img5, title: "Deorali Ropeway", subtitle: "Deorali, Gangtok" },
      { image: img2, title: "Tsomgo Lake", subtitle: "Gangtok-Nathula Highway" },
      { image: img3, title: "Old Silk Route", subtitle: "Zuluk" },
      { image: img4, title: "Hanuman Tok", subtitle: "Gangtok" },
      { image: img6, title: "Baba Harbhajan Singh", subtitle: "Tsomgo Lake Highway" },
      { image: img7, title: "Ganesh Tok", subtitle: "Gangtok" },
      { image: img8, title: "Tashi View Point", subtitle: "Gangtok" },
      { image: img9, title: "Ban Jhakri Falls", subtitle: "Sichey, Gangtok" },
      { image: northimg1, title: "Gurudongmar Lake", subtitle: "Gurudongmar Lake" },
      { image: northimg2, title: "Yumthang Valley", subtitle: "Yumthang" },
      { image: northimg3, title: "Zero Point", subtitle: "Yumesamdong" },
      { image: northimg4, title: "Lachen Valley", subtitle: "Lachen" },
      { image: northimg5, title: "Chungthang Valley", subtitle: "Chungthang" },
      { image: northimg6, title: "Lachung Valley", subtitle: "Lachung" },
      { image: northimg7, title: "Nathula China Border", subtitle: "Nathula" },
      { image: northimg8, title: "Rhodondendron Sanctuary", subtitle: "Shingba" },
      { image: westsouthimg1, title: "Rhododendron Sanctuary", subtitle: "Barsey" },
      { image: westsouthimg2, title: "Tathagata Tsal", subtitle: "Ravangla" },
      { image: westsouthimg3, title: "Siddheshwar Dham", subtitle: "Namchi" },
      { image: westsouthimg4, title: "Samdtuptse", subtitle: "Namchi" },
      { image: westsouthimg5, title: "Sky Walk", subtitle: "pelling" },
      { image: westsouthimg6, title: "Temi Tea Garden", subtitle: "Temi-Tarku" },
      { image: westsouthimg7, title: "Rose Garden", subtitle: "Namchi" },

    ],
    itineraries: [
      "09 Days All Sikkim",
    ],
  },
};